import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/classificationByOrigins/form'
import { api, actionCreators } from 'store/modules/classificationByOrigins'

const metadata = {
  icon: 'leaf',
  page: 'classificationByOrigins',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
